
import { Injectable } from '@angular/core';

import Swal from 'sweetalert2';

@Injectable({
    providedIn: 'root'
})
export class ToastrService {

    constructor() {

    }
    error(message) {
        Swal.fire({
            position: "top-end",
            icon: "error",
            title: message,
            showConfirmButton: false,
            timer: 300000000
          });

    }

    errorToastr(message, type?) {
        Swal.fire({
            position: "center",
            icon: "error",
            title: message,
            showConfirmButton: false,
            timer: 10000,
            showCloseButton: true,
          });

    }

    success(message) {
        Swal.fire({
            position: "top-end",
            icon: "success",
            title: message,
            showConfirmButton: false,
            timer: 300000000
          });

    }

    successToastr(message, type?) {
        Swal.fire({
            position: "center",
            icon: "success",
            title: message,
            showConfirmButton: false,
            timer: 10000,
            showCloseButton: true
          });

    }
}
